import {
  useElements,
  useStripe,
  PaymentElement,
  // PaymentRequestButtonElement,
} from "@stripe/react-stripe-js";
import { useState } from "react";
import { Spinner } from "@via/components/loading/loading.tsx";

interface PaymentSetupProps {
  onCardConfirmed: (paymentMethodId: string) => void;
}

const PaymentSetup: React.FC<PaymentSetupProps> = ({ onCardConfirmed }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!stripe || !elements) return;

    setIsSubmitting(true);

    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: window.location.href, // not used if you handle result here
      },
      redirect: "if_required", // Important for embedded flow
    });

    if (result.error) {
      setError(result.error.message || "Something went wrong.");
      setIsSubmitting(false);
      return;
    }

    if (result.setupIntent?.status === "succeeded") {
      onCardConfirmed(result.setupIntent.payment_method as string);
    } else {
      setError("Setup intent was not successful.");
    }

    setIsSubmitting(false);
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-4">
      <div className="text-2xl text-center font-bold mb-10">
        Payment Information
      </div>

      <PaymentElement />

      {error && (
        <div className="text-red-600 text-sm mt-1 transition-opacity duration-150">
          {error}
        </div>
      )}

      <div className="fixed bottom-0 left-0 w-full z-50">
        <div className="max-w-screen-md mx-auto flex justify-center gap-5 px-4 py-5">
          <button
            type="submit"
            disabled={!stripe || isSubmitting}
            className="mt-6 px-6 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-500 disabled:opacity-50">
            <Spinner loading={isSubmitting}>Next</Spinner>
          </button>
        </div>
      </div>
    </form>
  );
};

export default PaymentSetup;
